"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TimelineItem = _interopRequireDefault(require("../TimelineItem/TimelineItem"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.timeline-container {\n  position: relative;\n  display: flex;\n  flex-direction: column; }\n  .timeline-container .arrow {\n    position: absolute;\n    bottom: 0px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: end;\n    height: 100%;\n    margin-left: -0.5px;\n    z-index: -1; }\n    .timeline-container .arrow .line {\n      width: 1px;\n      height: 100%;\n      left: 0px;\n      top: 0px;\n      z-index: -1; }\n    .timeline-container .arrow .left {\n      width: 16px;\n      height: 16px;\n      transform: rotate(45deg);\n      transform-origin: 100% 100%; }\n    .timeline-container .arrow .right {\n      width: 16px;\n      height: 16px;\n      transform: rotate(-45deg);\n      transform-origin: 0% 100%; }\n  @media (max-width: 42rem) {\n    .timeline-container {\n      margin-left: 16px; }\n      .timeline-container .arrow {\n        justify-content: flex-start;\n        margin-left: -16px; } }\n";
  const fileName = "Timeline_Timeline";
  const element = document.querySelector("style[data-sass-component='Timeline_Timeline']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Timeline = _ref => {
  let {
    item,
    marginPercent
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "timeline-container sia-border-01-top sia-padding-06-top sia-padding-06-bottom sia-margin-06-bottom sia-margin-02-inline"
  }, item?.timeline_element?.map((el, i) => /*#__PURE__*/_react.default.createElement(_TimelineItem.default, _extends({
    key: el.title
  }, el, {
    index: i,
    position: i % 2 === 0 ? 'left' : 'right',
    marginPercent: marginPercent
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "arrow"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "left sia-border-01-bottom"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "line sia-border-01-right"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "right sia-border-01-bottom"
  })));
};
Timeline.propTypes = {
  item: _propTypes.default.object.isRequired,
  marginPercent: _propTypes.default.number
};
Timeline.defaultProps = {
  marginPercent: 25
};
var _default = exports.default = Timeline;